<template>
	<main id="main">
		<ApprovalReportFilter @toggle-filter="toggleFilter(false)" />
		<ApprovalReportList @toggle-filter="toggleFilter(true)" />
	</main>
</template>
<script setup>
import ApprovalReportFilter from "./ApprovalReportFilter"
import ApprovalReportList from "./ApprovalReportList"

const toggleFilter = (flag) => {
	var sideMenu = document.getElementById('sideMenu');
	if (flag) { //open filter
		sideMenu.style.transition = 'left 0.5s';
		sideMenu.style.left = '0';
	} else { //close filter
		sideMenu.style.left = '-450px';
	}
}
</script>
<style scoped src="@/assets/css/pc/reportList.css">
</style>